import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetSweepstakeById = (id: number) => {
  const get = useTypedApiClient({
    path: '/admin/contests/{id}',
    method: 'get',
  })

  return useQuery({
    queryKey: ['/sweepstakes', id],
    queryFn: async () => {
      const { data } = await get({ id })
      return data
    },
  })
}
